module.exports = __webpack_public_path__ + "static/img/icon-2.ecf6a62b.png";